module.exports = __webpack_public_path__ + "static/media/SR302-P6C Copy.bd69c91b.png";